import clsx from 'clsx'
import reverse from 'lodash/reverse'
import React, { FC, MutableRefObject } from 'react'

import SvgAngleLeft from '@Assets/SVG/AngleLeft'
import { useHorizontalCarouselButton } from '@Shared/Components/Carousels/HorizontalCarousel/hooks/UseHorizontalCarouselButton'

import styles from './HorizontalCarouselLeftArrow.module.scss'

export interface HorizontalCarouselLeftArrowProps {
  buttonClassName?: string
  buttonFloat: boolean
  buttonMoveOneField: boolean
  carouselRef: MutableRefObject<HTMLDivElement | null>
  gap: number
  unevenChildWidth?: boolean
}

export const HorizontalCarouselLeftArrow: FC<HorizontalCarouselLeftArrowProps> = ({
  buttonClassName,
  buttonFloat,
  buttonMoveOneField,
  carouselRef,
  gap,
  unevenChildWidth,
}) => {
  const { getScrollMovement, getScrollMovementLeftForUneven } = useHorizontalCarouselButton(carouselRef, buttonMoveOneField, gap)
  const getLeft = () => {
    if (!carouselRef.current) {
      return 0
    }
    if (unevenChildWidth) {
      const children = reverse(Array.from(carouselRef.current?.children || []))
      return getScrollMovementLeftForUneven(children)
    }
    const moveField = getScrollMovement((a, b) => a - b)
    return moveField < 0 ? 0 : moveField
  }

  return (
    <button
      // TODO: use translation for aria-label
      aria-label="Left"
      className={clsx(styles.horizontalCarouselLeftArrow, buttonFloat && styles.float, buttonClassName)}
      onClick={() => {
        carouselRef.current!.scrollTo({
          left: getLeft(),
          behavior: 'smooth',
        })
      }}
      type="button"
    >
      <SvgAngleLeft />
    </button>
  )
}
